import { render, staticRenderFns } from "./FormSettings.vue?vue&type=template&id=783cf854&scoped=true&"
import script from "./FormSettings.vue?vue&type=script&lang=js&"
export * from "./FormSettings.vue?vue&type=script&lang=js&"
import style0 from "./FormSettings.vue?vue&type=style&index=0&id=783cf854&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783cf854",
  null
  
)

export default component.exports